module.exports = __webpack_public_path__ + "img/icon-filtered.95277de7.svg";